import { render, staticRenderFns } from "./APPhysics1.vue?vue&type=template&id=27157ba6&scoped=true&"
import script from "./APPhysics1.vue?vue&type=script&lang=js&"
export * from "./APPhysics1.vue?vue&type=script&lang=js&"
import style0 from "./APPhysics1.vue?vue&type=style&index=0&id=27157ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27157ba6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VRow,VToolbar})
